import { ActionBlockButton } from "~/components/buttons/ActionBlockButton";
import Button from "~/components/buttons/Button/Button";
import type {
	MonthlyClosingCloseRequest,
	MonthlyClosingNonProjectPart,
	MonthlyClosingReopenRequest,
	MonthlyClosingStaffingPart,
} from "~/modules/timeTracking/api/monthlyClosing/monthlyClosingTypes.ts";
import { nonProjectLabel } from "~/modules/timeTracking/components/closingLists/closingListTypes.ts";

type ActionProps = {
	onCloseRequest: (request: MonthlyClosingCloseRequest) => void;
	onReopenRequest: (request: MonthlyClosingReopenRequest) => void;
};

type StaffingProps = ActionProps & {
	projectName: string;
	staffing: MonthlyClosingStaffingPart;
};

type NonProjectProps = ActionProps & {
	nonProject: MonthlyClosingNonProjectPart;
};

function getStaffingLabel(staffing: MonthlyClosingStaffingPart, projectName: string) {
	return `das Staffing „${staffing.orderName}“ im Projekt „${projectName}“`;
}

export function StaffingActions(props: StaffingProps) {
	const { staffing } = props;
	if (!staffing.isClosed) {
		return (
			<Button theme="none"
					size="xs"
					onClick={() => props.onCloseRequest({
						scope: { scope: "staffings", staffingIds: [staffing.staffingId] },
						label: getStaffingLabel(staffing, props.projectName),
					})}>
				Schließen
			</Button>
		);
	}
	if (!staffing.reopen) return null;
	return (
		<ActionBlockButton block={staffing.reopen}
						   theme="none"
						   size="xs"
						   onClick={() => props.onReopenRequest({
							   part: { part: "staffing", staffingId: staffing.staffingId },
							   label: getStaffingLabel(staffing, props.projectName),
						   })}>
			Wieder öffnen
		</ActionBlockButton>
	);
}

export function NonProjectActions(props: NonProjectProps) {
	if (!props.nonProject.isClosed) {
		return (
			<Button theme="none"
					size="xs"
					onClick={() => props.onCloseRequest({ scope: { scope: "nonProject" }, label: nonProjectLabel })}>
				Schließen
			</Button>
		);
	}
	if (!props.nonProject.reopen) return null;
	return (
		<ActionBlockButton block={props.nonProject.reopen}
						   theme="none"
						   size="xs"
						   onClick={() => props.onReopenRequest({ part: { part: "nonProject" }, label: nonProjectLabel })}>
			Wieder öffnen
		</ActionBlockButton>
	);
}
